import {
  Card,
  CardContent,
  CardActions,
  Button,
  Typography,
  Box,
  List,
  ListItem,
  Stack,
} from "@mui/material";
import { useUserData } from "../../hooks/use-data-user";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const CardKotaro = () => {
  const [showSecondCard, setShowSecondCard] = useState(true);
  const navigate = useNavigate();
  const { userDataQuery } = useUserData();
  const handleWhatsApp = () => {
    const message = encodeURIComponent(
      `Hola Kotaro, quiero fondear mi billetera con 115 USDT, mis datos son:\n\nUsuario: ${userDataQuery.data?.username}\nCorreo electrónico: ${userDataQuery.data?.email}`
    );
    const url = `https://api.whatsapp.com/send?phone=573233078257&text=${message}`;
    window.open(url, "_blank");
  };

  return (
    <>
      {showSecondCard ? (
        <Card
          sx={{
            maxWidth: { xs: "320px", md: "730px" },
            backgroundColor: "rgba(20, 20, 20, 1)",
            border: "1px solid #a95052",
            borderRadius: "12px",
            padding: { xs: "20px", md: "35px" },
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              justifyContent: "left",
              textAlign: "left",
              padding: "0px",
            }}
          >
            <Typography fontSize={16} color="white" sx={{ fontWeight: 400 }}>
              Has elegido fondear tu billetera mediante depósito o transferencia
              bancaria. Este proceso será gestionado por Kotaro, una empresa
              especializada en intercambio de criptomonedas que, a través de un
              convenio con Plusvalica, ofrece condiciones preferenciales a
              nuestra comunidad.
            </Typography>

            <Box
              component="img"
              src="../assets/logo-kotaro.png"
              alt="hola"
              margin="auto"
              pt={3}
              pb={2}
              width={100}
              height={100}
            />
            <Box
              component="img"
              src="../assets/kotaro.png"
              alt="hola"
              margin="auto"
              pb={3}
              width={102}
              height={17}
            />

            <Typography fontSize={16} color="white">
              Al continuar, serás contactado vía WhatsApp por un operador de
              Kotaro. El mensaje incluirá tus datos básicos:
            </Typography>
            <List sx={{ color: "white", paddingLeft: 4 }}>
              <ListItem
                sx={{
                  display: "list-item",
                  listStyleType: "disc",
                  paddingY: 0,
                }}
              >
                <Typography variant="body1">
                  Usuario: {userDataQuery.data?.username}
                </Typography>
              </ListItem>
              <ListItem
                sx={{
                  display: "list-item",
                  listStyleType: "disc",
                  paddingY: 0,
                }}
              >
                <Typography variant="body1">
                  Correo electrónico: {userDataQuery.data?.email}
                </Typography>
              </ListItem>
              <ListItem
                sx={{
                  display: "list-item",
                  listStyleType: "disc",
                  paddingY: 0,
                }}
              >
                <Typography variant="body1">Compra de 115 USDT</Typography>
              </ListItem>
            </List>

            <Typography paddingY={1} fontSize={16} color="white">
              El operador de Kotaro te preguntará el método de pago que
              prefieres utilizar:
            </Typography>
            <List sx={{ color: "white", paddingLeft: 4 }}>
              <ListItem
                sx={{
                  display: "list-item",
                  listStyleType: "disc",
                  paddingY: 0,
                }}
              >
                <Typography variant="body1">
                  Depósito en ventanilla bancaria
                </Typography>
              </ListItem>
              <ListItem
                sx={{
                  display: "list-item",
                  listStyleType: "disc",
                  paddingY: 0,
                }}
              >
                <Typography variant="body1">
                  Transferencia interbancaria
                </Typography>
              </ListItem>
              <ListItem
                sx={{
                  display: "list-item",
                  listStyleType: "disc",
                  paddingY: 0,
                }}
              >
                <Typography variant="body1">Depósito en cajero</Typography>
              </ListItem>
            </List>

            <Typography
              paddingY={2}
              fontSize={16}
              color="white"
              sx={{ fontWeight: 400 }}
            >
              Una vez confirmado el método de pago, Kotaro te indicará el monto
              exacto y los datos de la cuenta a la que debes realizar el
              depósito o transferencia.
            </Typography>
          </CardContent>

          <CardActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              variant="contained"
              width="100%"
              onClick={() => navigate("/payments")}
              sx={{
                px: "80px",
                paddingX: { md: "50px", xl: "50px" },
                fontSize: { xs: "14px", md: "16px", xl: "16px" },
                borderRadius: "40px",
                color: "#f0e5d2",
                backgroundColor: "#a95052",
                "&:hover": {
                  backgroundColor: "#8c3e47",
                  color: "white",
                },
                transition: "background-color 0.3s ease, color 0.3s ease",
              }}
            >
              REGRESAR
            </Button>
            <Button
              variant="contained"
              width="100%"
              onClick={() => setShowSecondCard(false)}
              sx={{
                px: "80px",
                paddingX: { md: "50px", xl: "50px" },
                fontSize: { xs: "14px", md: "16px", xl: "16px" },
                borderRadius: "40px",
                color: "#f0e5d2",
                backgroundColor: "#a95052",
                "&:hover": {
                  backgroundColor: "#8c3e47",
                  color: "white",
                },
                transition: "background-color 0.3s ease, color 0.3s ease",
              }}
            >
              CONTINUAR
            </Button>
          </CardActions>
        </Card>
      ) : (
        <Card
          sx={{
            maxWidth: { xs: "320px", md: "730px" },
            backgroundColor: "rgba(20, 20, 20, 1)",
            border: "1px solid #a95052",
            borderRadius: "12px",
            padding: { xs: "20px", md: "35px" },
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "left",
              justifyContent: "left",
              textAlign: "left",
              padding: "0px",
            }}
          >
            <Box
              component="img"
              src="../assets/logo-kotaro.png"
              alt="hola"
              margin="auto"
              pt={3}
              pb={2}
              width={100}
              height={100}
            />
            <Box
              component="img"
              src="../assets/kotaro.png"
              alt="hola"
              margin="auto"
              pb={3}
              width={102}
              height={17}
            />

            <Typography
              fontSize={16}
              color="white"
              marginBottom={3}
              sx={{ fontWeight: 400 }}
            >
              Después de completar el pago, Kotaro verificará la transacción y
              enviará a tu Plus Wallet los TID USDT que compraste. Después de
              recibir tu correo de confirmación puedes ir a ver las propiedades
              en Plusval Estate para completar tu primer compra.
            </Typography>
            <Box m="auto">
              <Button
                variant="contained"
                width="100%"
                onClick={handleWhatsApp}
                sx={{
                  px: "80px",
                  marginBottom: "40px",
                  paddingX: { md: "50px", xl: "50px" },
                  fontSize: { xs: "14px", md: "16px", xl: "16px" },
                  borderRadius: "40px",
                  color: "#f0e5d2",
                  backgroundColor: "#a95052",
                  "&:hover": {
                    backgroundColor: "#8c3e47",
                    color: "white",
                  },
                  transition: "background-color 0.3s ease, color 0.3s ease",
                }}
              >
                PAGAR CON KOTARO
              </Button>
            </Box>

            <Typography fontSize={16} color="white" sx={{ fontWeight: 800 }}>
              Aviso importante
            </Typography>

            <Typography paddingY={1} fontSize={16} color="white">
              El servicio de pago a través de transferencia o depósito es
              operado por Kotaro de manera externa a Plusvalestate.
            </Typography>
            <Typography
              paddingY={2}
              fontSize={16}
              color="white"
              sx={{ fontWeight: 400 }}
            >
              Plusvalica no se hace responsable por la negociación entre el
              usuario y Kotaro, ni por el cumplimiento de los compromisos entre
              ambas partes.
            </Typography>
            <Typography
              paddingY={2}
              fontSize={16}
              color="white"
              sx={{ fontWeight: 400 }}
            >
              Te recomendamos confirmar todos los detalles directamente con el
              operador antes de realizar cualquier pago.
            </Typography>
          </CardContent>

          <Stack
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: "20px",
              flexDirection: { xs: "column-reverse", md: "row" },
            }}
          >
            <Button
              variant="contained"
              width="100%"
              onClick={() => setShowSecondCard(true)}
              sx={{
                px: "80px",
                paddingX: { md: "50px", xl: "50px" },
                fontSize: { xs: "14px", md: "16px", xl: "16px" },
                borderRadius: "40px",
                color: "#f0e5d2",
                backgroundColor: "#a95052",
                "&:hover": {
                  backgroundColor: "#8c3e47",
                  color: "white",
                },
                transition: "background-color 0.3s ease, color 0.3s ease",
              }}
            >
              REGRESAR
            </Button>
            <Button
              variant="contained"
              width="100%"
              onClick={() => navigate("/")}
              sx={{
                px: "80px",
                paddingX: { md: "50px", xl: "50px" },
                fontSize: { xs: "14px", md: "16px", xl: "16px" },
                borderRadius: "40px",
                color: "#f0e5d2",
                backgroundColor: "#a95052",
                "&:hover": {
                  backgroundColor: "#8c3e47",
                  color: "white",
                },
                transition: "background-color 0.3s ease, color 0.3s ease",
              }}
            >
              VER PROPIEDADES
            </Button>
          </Stack>
        </Card>
      )}
    </>
  );
};

export default CardKotaro;
